import type { WidgetProps } from "react-jsonschema-form";

import "./fake-textarea.less";

export const FakeTextarea = (props: WidgetProps) => {
  return <div className="fake-textarea">{props.value}</div>;
};
